import React, { useState, Fragment } from "react";
import { FormGroup, Label, Button, Badge } from "reactstrap";
import style from "./styles.module.scss";
import { Mode } from "../../types";

const Attachments = ({ readonly, attachments, update, services, id }) => {

  function splitNameAndExt(filename) {
    const clean = (filename || "").trim();

    // Si empieza con "." y no tiene más puntos: archivo oculto sin extensión (".env")
    const firstDot = clean.indexOf(".");
    const lastDot = clean.lastIndexOf(".");

    if (lastDot <= 0) { // 0 => empieza con punto; -1 => sin punto
      return { name: clean, extension: "" };
    }

    // Extensiones compuestas comunes: tar.gz / tar.bz2 / tar.xz
    const lower = clean.toLowerCase();
    const compound = [".tar.gz", ".tar.bz2", ".tar.xz"];
    for (const ext of compound) {
      if (lower.endsWith(ext)) {
        const name = clean.slice(0, clean.length - ext.length);
        return { name, extension: ext.slice(1) }; // sin el punto
      }
    }

    // Caso general: último punto
    const name = clean.slice(0, lastDot);
    const extension = clean.slice(lastDot + 1);
    return { name, extension };
  }

  const MAX_SIZE = 5 * 1024 * 1024; // 5 MB

  const handleFileInput = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    const { name, extension } = splitNameAndExt(file.name);
    if (file.size <= MAX_SIZE) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileBlob = reader.result.split(",")[1];
        update({
          mode: Mode.Insert,
          id: Math.random().toString(36).substring(7),
          blob: fileBlob,
          new: true,
          extension,
          name,
        });
      };
      reader.onerror = (error) => {
        throw error;
      };
    } else {
      alert("File is too big! (Max. 5MB)");
      event.target = "";
    }
  };

  const handleDelete = (fileId) => {
    update({
      mode: Mode.Delete,
      id: fileId,
    });
  };

  const handleDownload = (file) => {
    if (id) {
      services.download({ assetId: id, attachmentId: file.AssetAttachmentId }).then((res) => {
        if (res.result.Code == 200) {
          const fileName = `${file.AssetAttachmentName}.${file.AssetAttachmentExtension}`;
          const element = document.createElement("a");
          element.setAttribute(
            "href",
            "data:application/octet-stream;base64," + encodeURIComponent(res.blob)
          );
          element.setAttribute("download", fileName);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        }
      });
    }
  };

  return (
    <FormGroup className="mb-4">
      <Label>Attachments</Label>
      {!readonly && (
        <div className={style.chooser}>
          <input
            type="file"
            id="file-chooser"
            accept="image/jpeg,image/gif,image/png,application/pdf"
            onChange={handleFileInput}
          />
          <Label className="btn btn-primary mb-2" for="file-chooser">
            <span style={{ color: "#fff !important" }}>
              <i className="fa fa-plus mr-1" aria-hidden="true"></i>
              Add attachment
            </span>
          </Label>
        </div>
      )}
      {attachments &&
        (attachments.length == 0 ? (
          <div className={style.container}>
            <span className="h6" style={{ textAlign: "center" }}>
              No Attachments
            </span>
          </div>
        ) : (
          <div className="attachments">
            {attachments.map((item) => (
              <Line
                key={item.AssetAttachmentId}
                file={item}
                remove={handleDelete}
                download={handleDownload}
              />
            ))}
          </div>
        ))}
    </FormGroup>
  );
};

const Line = ({ file, remove, download }) => (
  <div className={style.attachment}>
    <Badge color="info" className={style.extension}>
      {file.AssetAttachmentExtension}
    </Badge>
    <Button color="link" onClick={() => download(file)} className={style.name}>
      {file.AssetAttachmentName}.{file.AssetAttachmentExtension}
    </Button>
    <span className={style.delete} onClick={() => remove(file.AssetAttachmentId)}>
      <i className="fa fa-trash"></i>
    </span>
  </div>
);

export function getAttachments(changedFiles) {
  const attachments = [];
  Object.values(changedFiles).forEach((file) => {
    if (file.mode == Mode.Delete) {
      attachments.push({
        accountId: file.id,
      });
    } else {
      attachments.push({
        ...file,
      });
    }
  });

  return attachments;
}

export default Attachments;
